import React from 'react'
import memoWithName from '@/hocs/memoWithName'

const BadIcon = ({ white }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM5.5 13C5.5 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14C5.5 14 7.5 13 9 13C10.5 13 12.5 14 12.5 14C12.7761 14 13 13.7761 13 13.5C13 13.2239 12.5 13 12.5 13C12.5 13 10.5 12 9 12C7.5 12 5.5 13 5.5 13ZM8 6.5C8 7.32843 7.32843 8 6.5 8C5.67157 8 5 7.32843 5 6.5C5 5.67157 5.67157 7 6.5 7C7.32843 7 8 5.67157 8 6.5ZM11.5 8C12.3284 8 13 7.32843 13 6.5C13 5.67157 12.3284 7 11.5 7C10.6716 7 10 5.67157 10 6.5C10 7.32843 10.6716 8 11.5 8Z" fill={white ? '#FFFFFF' : '#F83D14'} />
  </svg>
)

export default memoWithName(BadIcon)
